<template>
  <i class="fa fa-fw fa-envelope-o"></i>
</template>

<script>
export default {
  name: 'Mail',
};
</script>

<style scoped>
.fa-envelope-o {
  color: #f39522;
}
</style>



// WEBPACK FOOTER //
// EmailIcon.vue?e96de678